import { useSelector } from 'react-redux';
import { IRootState } from '../store';

export const usePermission = () => {
    const { permissions, roles, user } = useSelector((s: IRootState) => s.auth);

    const isSuperAdmin = roles.includes('super-admin');

    const hasPermission = (permission: string) => {
        if (!user) return false;
        if (isSuperAdmin) return true;
        return permissions.includes(permission);
    };

    const hasAnyPermission = (list: string[]) => {
        if (!user) return false;
        if (isSuperAdmin) return true;
        return list.some((p) => permissions.includes(p));
    };

    const hasAllPermissions = (list: string[]) => {
        if (!user) return false;
        if (isSuperAdmin) return true;
        return list.every((p) => permissions.includes(p));
    };

    const hasRole = (role: string) => roles.includes(role);

    return { hasPermission, hasAnyPermission, hasAllPermissions, hasRole, isSuperAdmin };
};
